//* Vue Router
import type { RouteLocationResolvedGeneric } from "vue-router";
//* 全局配置
import { i18nOption } from "@/app/i18n";
//* 工具属性
import type { NavigateToRoute, NavigateToOptions } from "./src/types";

//* 路由解析函数
export const routerResolve = (
    route: string | NavigateToRoute,
    routeLanguage?: string
): { href: string; route: string | RouteLocationResolvedGeneric; options?: NavigateToOptions } => {
    //* 检测是否存在To信息
    if (!route) return { route: "", href: "" };

    //* 获取路由对象
    const router = useRouter();
    const setting = useRuntimeConfig();
    const language = routeLanguage || router.currentRoute.value?.meta?.routeLanguage || i18nOption.locale;
    //* 多语言路由转化
    const resolve = (route: RouteLocationResolvedGeneric | NavigateToRoute) => {
        const r = router.resolve({ name: route.name || undefined, hash: route.hash, query: route.query, params: route.params });
        if (r.name) return { href: setting.public.BASE_LINK_PREFIX + r.fullPath, route: r };
        else {
            return { href: "", route: "" };
        }
    };

    //* 检测是否是完整的HTTP链接
    if (typeof route == "string") {
        if (/^(http[s]?|mailto):.+/.test(route)) {
            return { href: route, route: route, options: { external: true } };
        } else {
            //* 解析路径获取路由并初始化路由名称
            const r = router.resolve(route);
            const rName = r.meta?.route?.toString() || r.name?.toString() || "";
            //* 校验是否存在当前语言环境的路由
            if (!rName) return { href: r.fullPath, route: route, options: { external: true } };
            else if (router.hasRoute(`${rName}_${language}`)) return resolve(Object.assign(r, { name: `${rName}_${language}` }));
            else {
                return { href: setting.public.BASE_LINK_PREFIX + r.fullPath, route: r };
            }
        }
    } else {
        //* 检测路由是否存在
        if (router.hasRoute(`${route.name}_${language}`)) return resolve(Object.assign(route, { name: `${route.name}_${language}` }));
        else if (router.hasRoute(route.name)) return resolve(route);
        else {
            return { href: "", route: "" };
        }
    }
};

//* navigateTo的二次封装
export const routerPush = (route: string | NavigateToRoute, options?: NavigateToOptions) => {
    //* 数据初始化
    const result = routerResolve(route);
    if (!result.route) return;
    else {
        return navigateTo(result.route, Object.assign(result?.options || {}, options));
    }
};
